import { LazyRoute } from "@appretio/shared";
import { ErrorBoundary, semanticThemeTokens } from "@appretio/ui-kit";
import { lazy } from "react";
import { Outlet, type RouteObject } from "react-router-dom";

const PurchaseReviewPage = lazy(() =>
  import("./pages/purchaseReviewPage/PurchaseReviewPage").then((m) => ({
    default: m.PurchaseReviewPage
  }))
);

const RangePlanPage = lazy(() =>
  import("./pages/rangePlanPage/RangePlanPage").then((m) => ({
    default: m.RangePlanPage
  }))
);

const ROOT = "assortment" as const;

const PATH = {
  PURCHASE_REVIEW: "purchase-review",
  RANGE_PLAN: "range-plan"
} as const;

const LABEL = {
  ROOT: "Assortment",
  PURCHASE_REVIEW: "Purchase Review",
  RANGE_PLAN: "Range Plan"
} as const;

const BG = semanticThemeTokens.backgroundGradient[3];

export const assortmentRoutes: RouteObject = {
  path: ROOT,
  handle: { label: LABEL.ROOT, background: BG },
  element: <Outlet />,
  children: [
    {
      path: PATH.RANGE_PLAN,
      handle: { label: LABEL.RANGE_PLAN, background: BG },
      element: (
        <ErrorBoundary level="route">
          <LazyRoute>
            <RangePlanPage />
          </LazyRoute>
        </ErrorBoundary>
      )
    },
    {
      // Analysis views are in-page tabs (`?tab=`), not nested routes.
      path: PATH.PURCHASE_REVIEW,
      handle: { label: LABEL.PURCHASE_REVIEW, background: BG },
      element: (
        <ErrorBoundary level="route">
          <LazyRoute>
            <PurchaseReviewPage />
          </LazyRoute>
        </ErrorBoundary>
      )
    }
  ]
};
